import axios from "@/utils/axios";
import {KeyMomentCut, tempKeyMomentCuts} from "@/types/keyMomentTypes";
import {KeyMomentFilters} from "@/utils/filterUtils";

export async function getKeyMomentCutsByIds(cutIds: string[], keyMomentFilters?: KeyMomentFilters) {
    const response =  await axios.post('key_moment_cut/v2/key_moments_by_cut_ids', {cutIds, km_filter: keyMomentFilters});
    return response.data
}

export async function updateMasterCut(cutId: string, cut: tempKeyMomentCuts) {
    const response =  await axios.put(`key_moment_cut/v2/master_cut/${cutId}`, {cut});
    return response.data
}

export async function createOrphanCutsCopy(cuts: KeyMomentCut[]) {
    const orphansBody = cuts.map(({coordinates, ...rest}) => ({...rest, type: "copy"}))
    const response =  await axios.post(`key_moment_cut/v2/orphan_cut_copy`, {cuts: orphansBody});
    return response.data
}

export async function updateCutsCopy(cuts: KeyMomentCut[]) {
    const cutsBody = cuts.map(({coordinates, ...rest}) => ({...rest}))
    const response =  await axios.put(`key_moment_cut/v2/update_cuts_copy`, {cuts: cutsBody});
    return response.data
}